/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Language =
  | 'de'
  | 'en'
  | 'fr'
  | 'it';

/** Input that contains all required and optional values for updating a user */
export type UpdateUserInput = {
  /** Optional: Country key */
  countryKey?: string | null | undefined;
  /** Optional: Country label */
  countryLabel?: string | null | undefined;
  /** Optional: Users first name */
  firstName?: string | null | undefined;
  /** Optional: Users language */
  language?: Language | null | undefined;
  /** Optional: Users last name */
  lastName?: string | null | undefined;
  /** Optional: School type key */
  schoolTypeKey?: string | null | undefined;
  /** Optional: School type label */
  schoolTypeLabel?: string | null | undefined;
  /** Optional: State key */
  stateKey?: string | null | undefined;
  /** Optional: State label */
  stateLabel?: string | null | undefined;
};

export type UpdateUserMutationVariables = Exact<{
  updateUserInput: Types.UpdateUserInput;
}>;


export type UpdateUserMutation = { updateUser: { user: { id: string, language: Types.Language, firstName: string, lastName: string } } };


export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateUserInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"updateUserInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateUserInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;